<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiInformation } from "@mdi/js";
export default {
  name: "MdiInformation",
  data() {
    return {
      svgPath: mdiInformation,
    };
  },
};
</script>
